export default __webpack_public_path__ + "static/node-2c2c2f0bf0bf07074fbe89fa0935ef0d.png";